<template>
  <el-header id="head">
    <div id="container">
      <router-link :to="validPath" :accesskey="navigationAccessKeys.home">
        <img id="wize_logo" alt="foodie logo" style="width:150px" src="@/assets/foodie-logo.png" />
      </router-link>
      <nav-bar v-if="authenticated" id="navBar" />
    </div>
    <el-container id="head__action-buttons">
      <div id="display-access-keys" class="hidden-xs-only">
        <common-button
          v-if="showButton"
          id="display-access-keys-button"
          :accesskey="navigationAccessKeys.accessKeysModal"
          class="secondary header-layout__display-access-keys-btn"
          data-test-selector="access-key-button"
          @click.prevent="$emit('toggleDisplayAccessKeys')"
        >
          {{ $t('accessKeys.displayListOfAccessKeysButton') }}
        </common-button>
      </div>
      <div id="logout">
        <common-button
          v-if="showButton"
          id="logout-button"
          :accesskey="navigationAccessKeys.logout"
          class="secondary uppercase"
          data-test-selector="logout-button"
          @click.prevent="$emit('logout')"
        >
          {{ $t('welcome.logoutButton') }}
        </common-button>
      </div>
    </el-container>
  </el-header>
</template>
<script>
import NavBar from '@/components/NavBar';
import { mapState } from 'vuex';
import { NAVIGATION_ACCESS_KEYS, CATERING_ROLE, ROUTES } from '@/constants';
import CommonButton from '@/components/common/CommonButton';

const { HOME, MENU } = ROUTES;

export default {
  name: 'Header',
  components: {
    NavBar,
    CommonButton,
  },
  props: {
    authenticated: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      locales: [],
      language: '',
      navigationAccessKeys: NAVIGATION_ACCESS_KEYS.navbar,
    };
  },
  computed: {
    ...mapState('user', { user: (state) => state.user }),
    isCateringUserRole() {
      return this.user.role === CATERING_ROLE;
    },
    validPath() {
      return this.authenticated && !this.isCateringUserRole ? MENU : HOME;
    },
    showButton() {
      return this.authenticated && this.user.role && !this.isCateringUserRole;
    },
  },
  created() {
    this.locales = Object.keys(this.$i18n.messages);
    this.language = this.$i18n.locale;
  },
};
</script>

<style scoped>
#head {
  width: 100%;
  padding: 8px;
  color: #333;
  display: center;
  box-shadow: inset 0 -1px 0 0 #cfcfcf;
}

#wize_logo {
  float: left;
}

#head__action-buttons {
  float: right;
}

.header-layout__display-access-keys-btn {
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/HeaderLayout.vue